<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.ManagerName"
          :label="$t('servicesystem.common_objects.partner_company.manager_name')" :rules="[requiredRule]" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.ManagerEmail"
          :label="$t('servicesystem.common_objects.partner_company.manager_email')" :rules="[requiredRule]" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="editItem.ManagerPhone"
          :label="$t('servicesystem.common_objects.partner_company.manager_phone')" :rules="[requiredRule]" clearable
          :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PartnerCompanyContactEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: {
      type: Function,
      default: () => { },
    },
  },
  components: {},

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>